(function () {
  'use strict';

  var CONFIG = {
    actions: {
      blurContent:  false,
      blockOverlay: false,
      redirect:     true
    },

    redirectUrl:    'https://www.google.com',
    overlayMessage: 'This store is not available right now.',
    blurAmountPx:   8,

    rescanIntervalMs: 1500,
    maxRescans:       20,

    allowTestParam: true,

    extensions: [
      {
        name: 'PPSPY',
        id: 'lppbajkahdbbadheilijoeegnfndhlab',
        resources: ['img/loading.png', 'img/loading-dark.png', 'img/ppspy_check_blue.svg', 'img/tracking_default.svg'],
        domKeywords: ['ppspy']
      },
      {
        name: 'TrendTrack',
        id: 'cncdmciajmaojninbopinpijdodjgfpd',
        resources: ['icon/128.png'],
        domKeywords: ['trendtrack', 'trend-track']
      },
      {
        name: 'Winning Hunter (extension)',
        id: 'eijfgedfkehblhdaiommcibimdgfgbop',
        resources: ['icon.png', 'icon128.png', 'icons/icon128.png', 'logo.png'],
        domKeywords: ['winninghunter', 'winning-hunter']
      }
    ],

    referrerBlocklist: [
      'winninghunter.com',
      'ppspy.com',
      'trendtrack.io'
    ],

    utmKeywords: ['winninghunter', 'ppspy', 'trendtrack']
  };

  var fired = {};

  function onDetect(method, name) {
    var sig = method + '|' + name;
    if (fired[sig]) return;
    fired[sig] = true;
    runActions();
  }

  var actionsApplied = {};
  function runActions() {
    var a = CONFIG.actions;

    if (a.blurContent && !actionsApplied.blur) {
      actionsApplied.blur = true;
      applyBlur();
    }
    if (a.blockOverlay && !actionsApplied.overlay) {
      actionsApplied.overlay = true;
      showOverlay();
    }
    if (a.redirect && !actionsApplied.redirect) {
      actionsApplied.redirect = true;
      try { location.replace(CONFIG.redirectUrl); } catch (e) { location.href = CONFIG.redirectUrl; }
    }
  }

  function applyBlur() {
    var css = 'filter:blur(' + CONFIG.blurAmountPx + 'px)!important;' +
              '-webkit-filter:blur(' + CONFIG.blurAmountPx + 'px)!important;' +
              'pointer-events:none!important;user-select:none!important;';
    if (document.body) document.body.setAttribute('style', (document.body.getAttribute('style') || '') + css);
  }

  function showOverlay() {
    var build = function () {
      if (document.getElementById('__antispy_overlay')) return;
      var d = document.createElement('div');
      d.id = '__antispy_overlay';
      d.setAttribute('style', [
        'position:fixed', 'inset:0', 'z-index:2147483647',
        'display:flex', 'align-items:center', 'justify-content:center',
        'background:#0b0b0c', 'color:#fff',
        'font:600 20px/1.5 system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
        'text-align:center', 'padding:24px'
      ].join(';'));
      d.textContent = CONFIG.overlayMessage;
      (document.body || document.documentElement).appendChild(d);
    };
    if (document.body) build();
    else document.addEventListener('DOMContentLoaded', build);
  }

  var ATTRS = ['src', 'href', 'data-src', 'style', 'background'];
  function inspectElement(el) {
    if (!el || el.nodeType !== 1) return;
    for (var i = 0; i < CONFIG.extensions.length; i++) {
      var ext = CONFIG.extensions[i];
      var needle = 'chrome-extension://' + ext.id;
      for (var j = 0; j < ATTRS.length; j++) {
        var v = el.getAttribute && el.getAttribute(ATTRS[j]);
        if (v && v.indexOf(needle) !== -1) {
          onDetect('extension-url', ext.name);
          return;
        }
      }
      var hay = ((el.id || '') + ' ' + (el.className && el.className.baseVal ? el.className.baseVal : el.className || '') +
                 ' ' + (el.getAttribute && (el.getAttribute('alt') || '')) + ' ' +
                 (el.getAttribute && (el.getAttribute('src') || ''))).toLowerCase();
      for (var k = 0; k < ext.domKeywords.length; k++) {
        if (hay.indexOf(ext.domKeywords[k]) !== -1) {
          onDetect('dom-keyword', ext.name);
          break;
        }
      }
    }
  }

  function scanDom(root) {
    try {
      var els = (root || document).querySelectorAll('*');
      for (var i = 0; i < els.length; i++) {
        inspectElement(els[i]);
        if (els[i].shadowRoot) scanDom(els[i].shadowRoot);
      }
    } catch (e) {}
  }

  function watchDom() {
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          inspectElement(node);
          if (node.querySelectorAll) scanDom(node);
          if (node.shadowRoot) scanDom(node.shadowRoot);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function probeImage(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      var done = false;
      var finish = function (ok) { if (!done) { done = true; resolve(ok); } };
      img.onload = function () { finish(true); };
      img.onerror = function () { finish(false); };
      img.src = url;
      setTimeout(function () { finish(false); }, 2500);
    });
  }

  function probeFetch(url) {
    return fetch(url, { method: 'GET' })
      .then(function (r) { return !!r; })
      .catch(function () { return false; });
  }

  function probeExtensions() {
    CONFIG.extensions.forEach(function (ext) {
      ext.resources.forEach(function (res) {
        var url = 'chrome-extension://' + ext.id + '/' + res;
        var isImg = /\.(png|jpg|jpeg|gif|webp|svg|ico)$/i.test(res);
        var probe = isImg ? probeImage(url) : probeFetch(url);
        probe.then(function (ok) {
          if (ok) onDetect('extension-probe', ext.name);
        });
      });
    });
  }

  function checkReferrer() {
    var ref = (document.referrer || '').toLowerCase();
    if (!ref) return;
    CONFIG.referrerBlocklist.forEach(function (dom) {
      if (ref.indexOf(dom.toLowerCase()) !== -1) {
        onDetect('referrer', dom);
      }
    });
  }

  function checkUtm() {
    var q = (location.search || '').toLowerCase();
    if (!q) return;
    CONFIG.utmKeywords.forEach(function (kw) {
      if (q.indexOf(kw.toLowerCase()) !== -1) {
        onDetect('utm', kw);
      }
    });
  }

  function checkTestParam() {
    if (!CONFIG.allowTestParam) return;
    var m = (location.search || '').match(/[?&]antispy_test=([^&]+)/i);
    if (m) onDetect('test', decodeURIComponent(m[1]));
  }

  function boot() {
    checkTestParam();
    checkReferrer();
    checkUtm();
    scanDom();
    watchDom();
    probeExtensions();

    var passes = 0;
    var iv = setInterval(function () {
      passes++;
      scanDom();
      if (passes >= CONFIG.maxRescans) clearInterval(iv);
    }, CONFIG.rescanIntervalMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
